import type { SVGIconsProps } from "../type";

export function GenuinIcon({ ...props }: SVGIconsProps) {
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M32.0002 0C14.3291 0 0.0713381 14.1867 0.000226976 31.8578C-0.0531064 46.1867 9.298 58.3467 22.2402 62.4889C28.3202 64.4267 34.9869 61.6889 37.7069 55.9111C38.5602 54.0978 39.0402 52.0711 39.0402 49.92V49.3156C39.0402 48.7644 38.4891 48.3733 37.9736 48.5689C36.0002 49.28 33.8669 49.6533 31.6447 49.6C22.0447 49.4044 14.3113 41.4222 14.4002 31.8222C14.4891 22.1867 22.3469 14.4 32.0002 14.4C41.7247 14.4 49.6002 22.2756 49.6002 32V49.92C49.6002 53.5289 48.818 56.96 47.4313 60.0356C57.3158 54.5956 64.0002 44.0711 64.0002 32C64.0002 14.3289 49.6713 0 32.0002 0Z" />
    </svg>
  );
}
